import { app } from '../../../../../app';
import { Controller } from './manage-user-details.controller';

app.component('companyUserDirectoriesManageUserDetails', {
    bindings: {
        account: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        currentCompany: '<',
        companyUser: '<',
        hardToken: '<',
        userSharedServiceAccounts: '<',
        userSharedNotes: '<',
        devicesForCompanyUser: '<',
        userSettings:'<'
    },
    controller: Controller,
    templateUrl: require('./manage-user-details.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/manage-user-details.component.js